import Component from '../core/Component'
import Scroll from '../services/Scroll'
import Dropdown from './Dropdown'

export const STATES = {
    DISABLED: 'is-disabled',
    NO_ITEMS: 'has-no-items'
}

export default class SelectedItems extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            dropdown: null,
            removes: [],
            counter: null,
            fallback: null
        }
    }

    prepare() {
        if (!this.ref.dropdown && !this.ref.counter) {
            return
        }

        this.fallbackInputs = Array.from(this.ref.fallback.querySelectorAll('input[type="radio"]'))

        this.defaultText = this.ref.counter.innerHTML

        this.dropdown = new Dropdown(this.ref.dropdown)
        this.dropdown.prepare()

        Scroll.on('resize', this.handleResize)
        this.handleResize()

        this.ref.removes.map($element => $element.addEventListener('click', this.handleRemoveClick))
    }

    destroy() {
        Scroll.off('resize', this.handleResize)

        if (this.dropdown) {
            this.dropdown.destroy()
        }

        this.dropdown = null
    }

    handleResize = () => {
        this.countItems()
    }

    handleRemoveClick = event => {
        let index = this.ref.removes.indexOf(event.target)
        this.ref.removes[index].closest('.form-Selected-item').remove()
        this.ref.removes.splice(index, 1)

        this.countItems()
        this.dropdown.handleResize()
    }

    countItems() {
        this.ref.counter.innerHTML = this.defaultText

        let suffix = ''
        let counter = this.ref.removes.length - 3

        if (counter < 1) {
            this.dropdown.ref.button.classList.add(STATES.DISABLED)
        } else {
            this.dropdown.ref.button.classList.remove(STATES.DISABLED)
        }

        if (counter > 4) {
            suffix = this.ref.counter.dataset.many
        } else {
            suffix = this.ref.counter.dataset.few
        }

        this.ref.counter.innerHTML = this.ref.counter.innerHTML.replace("X", counter)
        this.ref.counter.innerHTML += ' ' + suffix

        if (this.ref.removes.length == 0) {
            this.element.classList.add(STATES.NO_ITEMS)

            this.fallbackInputs.map($input => {
                $input.removeAttribute("disabled");
            })
        } else {
            this.element.classList.remove(STATES.NO_ITEMS)

            this.fallbackInputs.map($input => {
                $input.setAttribute("disabled", true);
            })
        }
    }
}
